import React, {useContext} from 'react';
import {injectIntl, FormattedMessage} from "react-intl";
import {useFormikContext} from "formik";

import Label from "components/input/new/Label";
import InputTextField from "components/input/new/InputTextField";

import {ProductShowContext} from "../../../../../context/ProductShowContext";

function BarcodeField(props) {
    const {values, handleChange, touched, errors, handleBlur, setFieldValue} = useFormikContext();
    const {isStockEasyUser, selectedVariation} = useContext(ProductShowContext);

    return (
        <>
            <Label htmlFor='barcode'>
                <FormattedMessage id='product.show.variation.form.field.barcode' />
            </Label>
            <InputTextField
                name='barcode'
                value={values.barcode}
                placeholder={props.intl.formatMessage({id: 'product.show.variation.form.field.barcode.placeholder'})}
                disabled={selectedVariation && isStockEasyUser}
                fullWidth
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.barcode && Boolean(errors.barcode)}
                helperText={touched.barcode && errors.barcode}
            />
        </>
    );
}

export default injectIntl(BarcodeField);
